import { render, staticRenderFns } from "./user_list.vue?vue&type=template&id=bc190f9c&scoped=true&"
import script from "./user_list.vue?vue&type=script&lang=js&"
export * from "./user_list.vue?vue&type=script&lang=js&"
import style0 from "./user_list.vue?vue&type=style&index=0&id=bc190f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc190f9c",
  null
  
)

export default component.exports